// fonts.ts
// The app's typefaces, following yogyism.org. Loaded once in
// public/index.html (Google Fonts).
//
//   FONT_DISPLAY  Space Grotesk   titles, headings (set upright, weight 600)
//   FONT_BODY     Space Grotesk   paragraphs, descriptions, buttons
//   FONT_MONO     JetBrains Mono  labels, tags, counters, small caps text
//
// Headings keep their own token so they can get a different face later by
// changing one line here (and the Google Fonts link in index.html).
// The *_CANVAS variants are for canvas `ctx.font` strings.

export const FONT_BODY    = "'Space Grotesk', system-ui, -apple-system, 'Segoe UI', sans-serif";
export const FONT_DISPLAY = FONT_BODY;
export const FONT_MONO    = "'JetBrains Mono', 'Courier New', monospace";

export const FONT_BODY_CANVAS    = "'Space Grotesk',Arial,sans-serif";
export const FONT_DISPLAY_CANVAS = FONT_BODY_CANVAS;
export const FONT_MONO_CANVAS    = "'JetBrains Mono','Courier New',monospace";
